import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { SortField } from '../../generic/classes/sortfield';
import { SortComponent } from '../../generic/component/sort/sort.component';
import { FilterService } from '../../generic/service/filter.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'products-sort',
    templateUrl: 'products.sort.component.html',
    styleUrls: [
        '../../../assets/style/_overview-bar.scss',
        './products.sort.component.scss',
    ],
    standalone: true,
    imports: [FormsModule],
})
export class ProductsSortComponent extends SortComponent implements OnInit {
    private filterService = inject(FilterService);

    activeSortFieldKey: string;
    @Output() sortChangeEvent = new EventEmitter();
    @Input() labelSortDescription: string;
    @Input() labelSortPotSize: string;
    @Input() labelSortHeight: string;
    @Input() labelSortEntryTime: string;
    @Input() labelSortAuctionTime: string;
    @Input() labelSortGrower: string;
    @Input() labelSortPrice: string;

    constructor() {
        super();
        this.activeSortFieldKey =
            this.filterService.getProductsActiveSortFieldKeyAndOrder();
    }

    getActiveSortFieldKey(): string {
        return this.activeSortFieldKey;
    }

    getSortFields(): SortField[] {
        return [
            new SortField(
                'totalDescription1',
                this.labelSortDescription,
                true,
                false,
            ),
            new SortField('GC1SortOrder', this.labelSortPotSize, true, false),
            new SortField('GC2SortOrder', this.labelSortHeight, true, false),
            new SortField(
                'ExpReceiptTime',
                this.labelSortEntryTime,
                true,
                false,
            ),
            new SortField(
                'AuctionTime',
                this.labelSortAuctionTime,
                true,
                false,
            ),
            new SortField('Producer', this.labelSortGrower, true, false),
            new SortField('UnitPrice', this.labelSortPrice, true, false),
        ];
    }

    ngOnInit(): void {
        super.ngOnInit();
    }

    onChangeActiveSortField($event: string) {
        this.activeSortFieldKey = $event;
        // Save the new active sort in session storage.
        this.filterService.setProductsActiveSortFieldKey(
            this.filterService.getFilterState(),
            this.activeSortFieldKey,
        );

        this.setApplicableSortFields();

        // Emits the event to the parent component, so that the parent,
        // can handles the reload of the products.
        this.sortChangeEvent.emit();
    }
}
